import { useQuery } from "@tanstack/react-query";
import { getMenu } from "../../../store/Menu/api";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

export const useGetMenu = ({ slug, config }) => {
    const history = useHistory();

    return useQuery(["menu-list", slug], () => getMenu(slug), {
        enabled: !!slug,
        ...config,
        onError: (error) => {
            history.push("/chain/menu");
            toast.error(error.message);
        },
    });
};
